import type { TalentEntityATI } from '@atlassian/search-client/common/types';

export const DEFAULT_TALENT_ENTITY_ATI: TalentEntityATI[] = ['ati:cloud:radar:position'];
